var _path, _rect, _path2, _rect2, _path3, _rect3;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWhatsappVoz = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
    fill: "#54CF60"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#54CF60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24L9.13085 19.8935C8.43171 18.6882 8.06495 17.3232 8.06877 15.9278C8.06877 11.5551 11.6447 8 16.0344 8C18.1662 8 20.1681 8.82509 21.6695 10.3232C23.1748 11.8213 24.0038 13.8137 24 15.9316C24 20.3042 20.4241 23.8593 16.0306 23.8593H16.0267C14.6934 23.8593 13.383 23.5247 12.2178 22.8935L8 24ZM12.4202 21.4601L12.6609 21.6046C13.6772 22.2053 14.8424 22.5209 16.0306 22.5247H16.0344C19.6829 22.5247 22.6552 19.5703 22.6552 15.9354C22.6552 14.1749 21.9675 12.5209 20.7182 11.2738C19.4689 10.0266 17.8032 9.34221 16.0344 9.34221C12.3859 9.3384 9.41356 12.2928 9.41356 15.9278C9.41356 17.1711 9.76122 18.384 10.426 19.4335L10.5826 19.6844L9.91404 22.1141L12.4202 21.4601Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8,
    y: 14,
    width: 1.5,
    height: 4,
    rx: 0.75,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 12.75C15.3 12.3358 15.6358 12 16.05 12C16.4643 12 16.8 12.3358 16.8 12.75V19.25C16.8 19.6642 16.4643 20 16.05 20C15.6358 20 15.3 19.6642 15.3 19.25V12.75Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 14,
    width: 1.5,
    height: 4,
    rx: 0.75,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWhatsappVoz, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/whatsapp-voz.52d5c3ef.svg";
export { ForwardRef as ReactComponent };